import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const veterinaryMedicationQuantity = enumerated({
  tablet: 'Comprimido',
  capsule: 'Cápsula',
  liquid: 'Líquido',
  syrup: 'Xarope',
  drops: 'Gotas',
  suspension: 'Suspensão',
  injectable: 'Injetável',
  ampoule: 'Ampola',
  vial: 'Frasco-ampola',
  ointment: 'Pomada',
  cream: 'Creme',
  gel: 'Gel',
  spray: 'Spray',
  shampoo: 'Shampoo',
  powder: 'Pó',
  sachet: 'Sachê',
  paste: 'Pasta',
  solution: 'Solução',
  milliliter: 'ml',
  other: 'Outro',
})

export const veterinaryMedicationUnitOptions = (veterinaryMedicationQuantity.getMeta()
  ?.keysAndLabels ?? {}) as Record<string, string>

export const veterinaryMedicationObject = z.object({
  id: z.string().uuid(),
  name: z.string(),
  quantity: z.number(),
  quantityUnit: veterinaryMedicationQuantity,
  observations: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString(),
  updatedAt: dateOrIsoString(),
  deletedAt: dateOrIsoString().nullish(),
})

export type VeterinaryMedicationType = z.infer<typeof veterinaryMedicationObject>

export const propertyMap = {
  id: sql`id`,
  name: sql`name`,
  quantity: sql`quantity`,
  quantityUnit: sql`quantity_unit`,
  observations: sql`observations`,
  clientId: sql`client_id`,
  insertUserId: sql`insert_user_id`,
  editUserId: sql`edit_user_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
